// extracted by mini-css-extract-plugin
export default {"hero":"gOjb94XE","list":"Z6uGyAcH"};